import React from 'react';

import PropTypes from 'prop-types';

import Avatar from './Avatar';

const AvatarWithEmail = ({ avatarColor, email, fullName, initials }) => (
  <div className="flex gap-2 items-center">
    <Avatar backgroundColor={avatarColor} initials={initials} />

    <div className="grid">
      <span className="truncate text-sm font-medium text-foreground">{fullName}</span>
      <span className="truncate text-xs text-foreground">{email}</span>
    </div>
  </div>
);

AvatarWithEmail.propTypes = {
  avatarColor: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  initials: PropTypes.string.isRequired,
};

export default AvatarWithEmail;
